<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_region' | translate: lang }}</h5>
  <button
    (click)="modalService.closeOutletModals('public')"
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
  >
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">
  <div class="elems">
    <div class="elem" (click)="onSelect('na')" *ngIf="game === 'lol' || game === 'wild-rift' || game === 'tft' || game === 'valorant' || game === 'marvel'">
      <img src="https://cdn.ggboost.com/images/regions/north-america.webp" alt=""/>
      <p class="text-mon mt-2 text-center">NA</p>
    </div>
    <div class="elem" (click)="onSelect('oce')" *ngIf="game === 'lol' || game === 'wild-rift' || game === 'tft' || game === 'valorant' || game === 'marvel'" >
      <img src="https://cdn.ggboost.com/images/regions/oceania.webp" alt=""/>
      <p class="text-mon mt-2 text-center">OCE</p>
    </div>
    <div class="elem" (click)="onSelect('euw')" *ngIf="game === 'lol' || game === 'tft'">
      <img src="https://cdn.ggboost.com/images/regions/europe-west.webp" alt=""/>
      <p class="text-mon mt-2 text-center">EUW</p>
    </div>
    <div class="elem" (click)="onSelect('eune')" *ngIf="game === 'lol' || game === 'tft'">
      <img src="https://cdn.ggboost.com/images/regions/europe-east.webp" alt=""/>
      <p class="text-mon mt-2 text-center">EUNE</p>
    </div>
    <div class="elem" (click)="onSelect('eu')" *ngIf="game === 'valorant' || game === 'wild-rift' || game === 'marvel'">
      <img src="https://cdn.ggboost.com/images/regions/europe.webp" alt=""/>
      <p class="text-mon mt-2 text-center">EU</p>
    </div>
    <div class="elem" (click)="onSelect('me')" *ngIf="game === 'lol' || game === 'tft' || game === 'marvel'">
      <img src="https://cdn.ggboost.com/images/regions/middle-east.webp" alt=""/>
      <p class="text-mon mt-2 text-center">ME</p>
    </div>
    <div class="elem" (click)="onSelect('americas')" *ngIf="game === 'apex' || game === 'cs2'">
      <img src="https://cdn.ggboost.com/images/regions/americas.webp" alt=""/>
      <p class="text-mon mt-2 text-center">AMERICAS</p>
    </div>
    <div class="elem" (click)="onSelect('europe')" *ngIf="game === 'apex' || game === 'cs2' ">
      <img src="https://cdn.ggboost.com/images/regions/europe.webp" alt=""/>
      <p class="text-mon mt-2 text-center">EUROPE</p>
    </div>
    <div class="elem" (click)="onSelect('oceania')" *ngIf="game === 'apex' || game === 'cs2'">
      <img src="https://cdn.ggboost.com/images/regions/oceania.webp" alt=""/>
      <p class="text-mon mt-2 text-center">OCEANIA</p>
    </div>

    <!--<div class="elem" (click)="onSelect('asia')" *ngIf="game === 'apex' || game === 'cs2'">
      <img src="https://cdn.ggboost.com/images/regions/oce.png" alt=""/>
      <p class="text-mon mt-2 text-center">ASIA</p>
    </div>-->
    <!-- <div class="elem" (click)="onSelect('americas')" *ngIf="game === 'overwatch' || game === 'marvel'">
      <img src="https://cdn.ggboost.com/images/regions/americas.webp" alt=""/>
      <p class="text-mon mt-2 text-center">AMERICAS</p>
    </div>
    <div class="elem" (click)="onSelect('europe')" *ngIf="game === 'overwatch' || game === 'marvel'">
      <img src="https://cdn.ggboost.com/images/regions/europe.webp" alt=""/>
      <p class="text-mon mt-2 text-center">EUROPE</p>
    </div>
    <div class="elem" (click)="onSelect('oceania')" *ngIf="game === 'overwatch'">
      <img src="https://cdn.ggboost.com/images/regions/oceania.webp" alt=""/>
      <p class="text-mon mt-2 text-center">OCEANIA</p>
    </div> -->
  </div>
</div>
